(() => {
  const roots = document.querySelectorAll('[data-responsibility-story]');

  roots.forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';

    const progress = root.querySelector('[data-reading-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const rect = root.getBoundingClientRect();
      const distance = Math.max(root.offsetHeight - window.innerHeight, 1);
      const value = Math.min(Math.max(-rect.top / distance, 0), 1);
      progress.style.width = `${value * 100}%`;
    };

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();

    const shareButton = root.querySelector('[data-share-story]');
    const shareStatus = root.querySelector('[data-share-status]');
    shareButton?.addEventListener('click', async () => {
      const data = { title: document.title, url: window.location.href };

      try {
        if (navigator.share) {
          await navigator.share(data);
          if (shareStatus) shareStatus.textContent = 'Share menu opened.';
          return;
        }

        await navigator.clipboard.writeText(data.url);
        if (shareStatus) shareStatus.textContent = 'Link copied.';
      } catch (error) {
        if (error?.name === 'AbortError') return;
        if (shareStatus) shareStatus.textContent = 'Copy the link from your browser.';
      }
    });

    root.querySelectorAll('details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      detail.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      });
    });
  });
})();
